module.exports = __webpack_public_path__ + "static/media/handoff-start-highlight.623d1e0e.png";